"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
// Private methods
var localStorage = function localStorage() {
  return window && window.localStorage || {
    /* eslint-disable no-console */
    setItem: function setItem() {
      return console.warn('Cannot set item: no local storage available');
    },
    getItem: function getItem() {
      return console.warn('Cannot get item: no local storage available');
    }
    /* eslint-enable no-console */
  };
};

/**
 * Handles the getting and setting of local storage.
 * Wraps the browsers native functionality in type friendly calls.
 *
 * IMPORTANT: This class has a programmed mock in the __mocks__ folder
 */
var typedLocalStorage = {
  /**
   * Put a string into local storage.
   */
  setString: function setString(key, value) {
    return localStorage().setItem(key, value);
  },
  /**
   * Get a string from local storage.
   */
  getString: function getString(key) {
    return localStorage().getItem(key);
  },
  /**
   * Put a number into local storage.
   */
  setNumber: function setNumber(key, value) {
    return localStorage().setItem(key, parseInt(value, 10));
  },
  /**
   * Get a number from local storage. Will return NaN if the value is
   * falsy or cannot be parsed.
   */
  getNumber: function getNumber(key) {
    return parseInt(localStorage().getItem(key), 10);
  },
  /**
   * Transform the value into a string respresentation and then store it in
   * local storage.
   */
  setObject: function setObject(key, value) {
    return localStorage().setItem(key, JSON.stringify(value));
  },
  /**
   * Get the string representation of the value for the key from local storage
   * and then revert the transformation turning it back into an object.
   *
   * @param key
   */
  getObject: function getObject(key) {
    var value = localStorage().getItem(key);
    return value && JSON.parse(value);
  }
};
var _default = exports["default"] = typedLocalStorage;
//# sourceMappingURL=typedLocalStorage.js.map